<template>
  <b-modal
    id="annonce-delete-modal"
    ref="modal"
    :cancel-title="$t('Cancel')"
    :ok-title="$t('Delete')"
    centered
    hide-header
    ok-variant="danger"
    @cancel="hideModal"
    @close="hideModal"
    @ok="handleOk">

    <div class="delete-container">
      <div class="d-flex justify-content-between align-items-center mb-4">
      <span
        class="page-title"> {{
          $t('Delete') + ' ' + theArticle + (beginsWithVoyel ? '' : ' ') + $t(itemToString)
        }} </span>
        <i class="ph-custom ph-x-bold cursor" @click="hideModal"/>
      </div>
      <p class="content">{{ $t('annonce.confirm.delete.title') }}</p>

      <p class="mb-4 mt-4 content">
        {{ $t('annonce.confirm.delete.admin') }}
      </p>
    </div>
  </b-modal>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'AnnonceDeleteModal',

  props: {
    selectedItem: Object,
    itemToString: String,
    theArticle: String,
    beginsWithVoyel: Boolean,
    selectedItemName: String,
  },

  emits: ['didDeleteItem'],

  methods: {

    handleOk(bvModalEvt) {
      bvModalEvt.preventDefault() // Prevent modal from closing
      this.handleSubmit()
    },

    handleSubmit() {
      api
        .delete(`/annonce/askToDeleteAnnonceGrandPublic/${this.selectedItem}`)
        .then(response => {
          this.$bvToast.toast(this.$i18n.t('Annonce.deleted'), {
            title: this.$i18n.t('Success.title'),
            autoHideDelay: 4000,
            toaster: 'b-toaster-bottom-right',
            solid: true
          });
          this.$router.push({name: 'MyAnnonce'});
        })
        .catch((error) => {
          if (!error.response) {
            console.log("error", error);
          }
          if (error.response && (error.response.status === 401 || error.response.status === 404)) {
            this.$bvToast.toast(this.$i18n.t(error.response.data.message), {
              title: this.$i18n.t('Error.title'),
              autoHideDelay: 4000,
              toaster: 'b-toaster-bottom-right',
              solid: true
            });
          }
        })
    },

    hideModal() {
      this.$bvModal.hide('annonce-delete-modal')
    },
  },

}
</script>

<style>
.cursor:hover {
  cursor: pointer;
}

/** pour éviter les 17px de padding qui s'ajoutent en responsive */
#annonce-delete-modal {
  padding-left: 0px !important;
}

#annonce-delete-modal .modal-content,
#annonce-delete-modal .modal-header,
#annonce-delete-modal .modal-body,
#annonce-delete-modal .modal-footer {
  background-color: var(--main-black-dark) !important;
}

#annonce-delete-modal .modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start !important;
  padding: 0;
  border-bottom: none;
}


#annonce-delete-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}


@media (max-width: 767px) {
  #annonce-delete-modal .modal-content {
    display: flex;
    border-radius: 0px;
    overflow: auto;
  }

  #annonce-delete-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-delete-modal .modal-body {
    display: flex;
    justify-content: center;
    align-items: flex-start;
  }

  #annonce-delete-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-delete-modal .modal-content {
    padding: 0;
    border-radius: 0;
  }

  #annonce-delete-modal .modal-header-content, .title-share-container {
    padding: 10px;
  }
}


#annonce-delete-modal .btn-secondary {
  background-color: var(--main-black-dark) !important;
  border-color: var(--main-grey-light) !important;
  color: var(--main-white);
  border-radius: var(--main-border-radius);
  padding: 12px 20px;
  font-size: var(--content-font-size);
}

#annonce-delete-modal .btn-secondary:hover:not([disabled]) {
  background-color: var(--main-black-medium) !important;
}


#annonce-delete-modal .copy-clipboard {
  background-color: rgb(51, 51, 51);
}

</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnonceCreate/AnnonceDeleteModal.vue